import { useMutation } from '@northladder/services';
import {
  ErrorEventsEnum,
  errorLogToRemoteUtil,
  IApiError,
} from '@northladder/utilities';

import { ILoginUserData } from '../types';
import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track the validate user login otp mutation keys in react query cache.
 */
const MUT_VALIDATE_USER_LOGIN_OTP = 'validate-user-login-otp';

interface IValidateUserLoginOTPOptions {
  onErrorCallback: (err: IApiError) => void;
  onSuccessCallback: (loginData: ILoginUserData) => void;
}

/**
 * This verifies the otp sent to the user's mobile during login, and
 * return the user's login profile data if the otp is valid.
 */
export const useValidateUserLoginOTPMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: IValidateUserLoginOTPOptions) => {
  const { mutate, isPending, error, data } = useMutation({
    mutationKey: [MUT_VALIDATE_USER_LOGIN_OTP],
    networkMode: 'always',
    retry: false,
    mutationFn: USER_ACCOUNTS_API.validateUserLoginOTP,
    onSuccess: onSuccessCallback,
    onError: (err: IApiError) => {
      onErrorCallback(err);
      errorLogToRemoteUtil({
        error,
        errorCode: ErrorEventsEnum.ERROR_IN_API_CALL,
        errorTitle: 'useValidateUserLoginOTPMutation Error',
        message: err.message,
      });

      return err;
    },
  });

  return {
    error,
    data,
    isPending,
    validateUserLoginOTP: mutate,
  };
};
